export default function LoginFooter({ onClick }) {
  return (
    <div className="font-[poppins] text-xs text-[#535862] font-normal leading-[20px] tracking-[0%]">
      ¿Necesitas ayuda?{' '}
      <button
        onClick={onClick}
        className="font-medium text-[#061F5B] cursor-pointer hover:underline hover:text-[#092F7B]"
      >
        Contactar a soporte
      </button>
    </div>
  );
}
